import { TextConfigDefault } from '../config/text/nb-NO';

export type TextConfig = TextConfigDefault;

declare global {
  interface Window {
    altibox: {
      validators: {
        userpassword: (password: string) => boolean;
      },
      commons: {
        countryCode: () => string;
        isProduction: () => boolean;
        isAT: () => boolean;
      },
    };
  }
}

export interface PartnerListItem {
  name: string;
  hostname: string;
  partnerId: number;
  countryCode: string;
  platform: string;
}

export type PartnerList = PartnerListItem[];

export interface PartnerInfo {
  partnerNumber: string;
  hostname: string;
  platform: string;
  name: string;
}

export interface PartnerHostnamesApiResponse {
  [index: string]: {
    hostname: string;
  };
}

export enum CreateUserResultTypes {
  USER_EXISTS = 'USER_EXISTS',
  USER_CREATE = 'USER_CREATE',
  USER_CREATED = 'USER_CREATED',
  USER_CREATE_FAILED = 'USER_CREATE_FAILED',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_MULTIPLE_MATCHES = 'USER_MULTIPLE_MATCHES',
  MAIL_VERIFICATION_SENT = 'MAIL_VERIFICATION_SENT',
  TIMEOUT = 'TIMEOUT',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  CRM_BLOCKED = 'CRM_BLOCKED',
  LEGACY_PIN_VERIFIED = 'LEGACY_PIN_VERIFIED',
  LEGACY_VERIFY_OFFCODE = 'LEGACY_VERIFY_OFFCODE',
  LEGACY_USER_FINALIZED = 'LEGACY_USER_FINALIZED',
  LEGACY_FORGOT_PIN = 'LEGACY_FORGOT_PIN',
  LEGACY_PIN_SENT = 'LEGACY_PIN_SENT',
  SPINNER = 'SPINNER',
}

export enum Platforms {
  LEGACY = 'legacy',
  MIGRATED = 'migrated',
  BLOCKED = 'blocked',
}

export interface DefaultComponentProps {
  textConfig: TextConfig;
}

export interface FormSubmitionValues {
  mobileNumber: string;
  email: string;
  partnerNumber: string;
  customerNumber: string; // legacy
  pin: string; // legacy
}

export interface SubmitValues {
  mobileNumber: string;
  email: string;
  partnerNumber: string;
}

export interface SubmitValuesLegacy {
  customerNbr: string;
  pin: string;
}

export enum FormStatus {
  INITIAL,
  SUBMITTING,
  TRIED_SUBMITTING,
}

export interface ValidationFeedback {
  partner: string;
  phone: string;
  email: string;
  customerNumber: string;
  pin: string;
}

export interface CreateUserAPIResponse {
  result: string;
}

export interface ReferredPartnerQueryString {
  partnerNumber?: string;
}

export enum MessageCodes {
  NOT_AUTHENTICATED_6003 = '6003',
  USER_ALREADY_EXIST_6004 = '6004',
  INVALID_OFFCODE_6008 = '6008',
  PASSWORD_TOO_WEAK_6010 = '6010',
  USERNAME_TAKEN_6013 = '6013',
}
